// import { slideToggle } from './slide-toggle';

// document.addEventListener('DOMContentLoaded', () => {
//     setupMobileMenu();
// });

// function setupMobileMenu() {
//     // Handle clicks outside of the sidebar menu - to close it
//     document.addEventListener('click', e => {
//         const openMenus = document.querySelectorAll('.sidebar-menu .sidebar.open');
//         if (!openMenus.length) {
//             return;
//         }

//         e.preventDefault();
//         openMenus.forEach(menuSidebarElement => {
//             menuSidebarElement.parentElement.querySelector('.toggle.open').classList.remove('open');
//             menuSidebarElement.classList.remove('open');
//         });
//     });

//     // Prevent clicks inside the sidebar menu from closing it (see handler above)
//     document.querySelectorAll('.sidebar-menu').forEach(sidebarMenuElement =>
//         sidebarMenuElement.addEventListener('click', e => {
//             e.stopPropagation();
//         })
//     );

//     // Toggle the related sidebar menu
//     document.querySelectorAll('.sidebar-menu .toggle').forEach(toggleElement =>
//         toggleElement.addEventListener('click', e => {
//             e.stopPropagation();
//             toggleElement.classList.toggle('open');
//             toggleElement.parentElement.querySelector('.sidebar').classList.toggle('open');
//         })
//     );

//     // Toggle submenu
//     document.querySelectorAll('.sidebar-menu .menu-item-has-children > a').forEach(linkElement => {
//         let arrowElement = document.createElement('i');
//         arrowElement.classList = 'fa-solid fa-angle-down arrow';
//         arrowElement.addEventListener('click', e => slideToggle(e.target.parentElement.querySelector('.sub-menu'), 300));

//         linkElement.after(arrowElement);
//     });

//     // Hide submenu on load
//     document.querySelectorAll('.sidebar-menu .sub-menu').forEach(subMenuElement =>
//         subMenuElement.style.display = 'none'
//     );
// }
import { slideToggle } from './slide-toggle';

document.addEventListener('DOMContentLoaded', () => {
    setupMobileMenu();
    // setupDesktopMenu();
});

function setupMobileMenu() {
    // Handle clicks outside of the sidebar menu - to close it
    document.addEventListener('click', e => {
        const openMenus = document.querySelectorAll('.sidebar-menu .sidebar.open');
        if (!openMenus.length) {
            return;
        }

        e.preventDefault();
        openMenus.forEach(menuSidebarElement => {
            menuSidebarElement.parentElement.querySelector('.toggle.open').classList.remove('open');
            menuSidebarElement.classList.remove('open');
        });
    });

    // Prevent clicks inside the sidebar menu from closing it (see handler above)
    document.querySelectorAll('.sidebar-menu').forEach(sidebarMenuElement =>
        sidebarMenuElement.addEventListener('click', e => {
            e.stopPropagation();
        })
    );

    // Toggle the related sidebar menu
    document.querySelectorAll('.sidebar-menu .toggle').forEach(toggleElement =>
        toggleElement.addEventListener('click', e => {
            e.stopPropagation();
            toggleElement.classList.toggle('open');
            toggleElement.parentElement.querySelector('.sidebar').classList.toggle('open');
        })
    );

    // Toggle submenu
    document.querySelectorAll('.sidebar-menu .menu-item-has-children > a').forEach(linkElement => {
        let arrowElement = document.createElement('i');
        arrowElement.classList = 'fa-solid fa-angle-down arrow';
        arrowElement.addEventListener('click', e => slideToggle(e.target.parentElement.querySelector('.sub-menu'), 300));

        linkElement.after(arrowElement);
    });

    // Hide submenu on load
    document.querySelectorAll('.sidebar-menu .sub-menu').forEach(subMenuElement =>
        subMenuElement.style.display = 'none'
    );
}